import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ModuleDetailsData } from '../models/module-catalog/moduleDetailsData';
import { ModuleRequestDetails } from '../models/request/moduleRequestDetails.model';
import { Response } from '../models/common/response.model';

@Injectable({
  providedIn: 'root'
})
export class ModulerequestService {

   private readonly baseURL = `${environment.apiUrl}/ModuleRequest`;

      constructor(private readonly httpClient: HttpClient) {}

      // Module Request
       createModuleRequestDetails(moduleRequest: ModuleRequestDetails, isAutoApprove : boolean): Observable<number> {
        const params = new HttpParams().set('isAutoApprove', isAutoApprove.toString())
        return this.httpClient.post<number>(this.baseURL, moduleRequest, {params});
      }

      // Get Module Request details for approve or reject or add in Risk-Database
      getModuleRequestDetailsByRequestId(requestId: number): Observable<Response<ModuleDetailsData>> {
        return this.httpClient.get<Response<ModuleDetailsData>>(this.baseURL +'/'+`${requestId}`);

      }

      // Approve or Deny Module Request in Risk-Database
     approveOrDenyModuleRequestDetails(approveDenyModuleRequest: ModuleDetailsData, requestId:number, isModuleApproveFlag:boolean): Observable<number> {
     const params = new HttpParams().set('isModuleApproveFlag', isModuleApproveFlag.toString());
     return this.httpClient.put<number>(this.baseURL +'/'+`${requestId}`, approveDenyModuleRequest, { params });
     }
   // Add Module
   AddModuleDetails(addModule: ModuleDetailsData, requestId:number): Observable<number> {
    return this.httpClient.post<number>(this.baseURL +'/'+requestId, addModule);

    }
}
